/* eslint-disable camelcase */
import axios from "axios";
import { requiredParam } from "@utils/func";

const getCompanyUsers = ({ companyId = requiredParam("companyId") } = {}) => {
  return axios.get(`companies/${companyId}/users`);
};

// Add a user (must be a new user).
// To add a user that already exists in the system
// to a company that exists in the system
// user postCompanyUser instead.
const postUser = ({
  companyId = requiredParam("companyId"),
  firstName = requiredParam("firstName"),
  lastName = requiredParam("lastName"),
  email = requiredParam("email"),
  password = "",
  roleId = requiredParam("roleId"),
} = {}) => {
  const data = {
    company_id: companyId,
    first_name: firstName,
    last_name: lastName,
    email,
    username: email,
    role: roleId,
  };

  if (password) {
    data.password = password;
  }
  return axios.post("users", data);
};

// Add a company user (must already exist in the system).
// To add a user that does not have an account already,
// use postUser instead.
const postCompanyUser = ({
  companyId = requiredParam("companyId"),
  userId = requiredParam("userId"),
  // Default is admin role
  roleId = "9d3c0b01-2012-4198-99da-cd34f97f2e0d",
} = {}) => {
  const data = {
    company: companyId,
    user: userId,
    role: roleId,
  };

  return axios.post("company-users", data);
};

// Update a company user
const patchCompanyUser = ({
  companyUserId = requiredParam("companyUserId"),
  data = requiredParam("data"),
} = {}) => {
  return axios.patch(`company-users/${companyUserId}`, data);
};

// Delete a company user.
// Does not delete a user from the system.
const deleteCompanyUser = ({
  companyUserId = requiredParam("companyUserId"),
} = {}) => {
  return axios.delete(`company-users/${companyUserId}`);
};

// Resend user email
const postCompanyUserSignupEmail = ({
  email = requiredParam("email"),
  companyId = requiredParam("companyId"),
} = {}) => {
  return axios.post(`companies/${companyId}/${email}/sign-up-email`, {
    data: {},
  });
};

export {
  getCompanyUsers,
  postUser,
  postCompanyUser,
  patchCompanyUser,
  deleteCompanyUser,
  postCompanyUserSignupEmail,
};
